import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { METHOD } from "../../data/content";

function ChapterVisual({ m }) {
  if (m.media) {
    return (
      <div className="relative aspect-[4/3] overflow-hidden border border-white/[0.06]">
        {m.mediaType === "video" ? (
          <video src={m.media} muted loop playsInline autoPlay className="absolute inset-0 w-full h-full object-cover" />
        ) : (
          <img src={m.media} alt={m.t} className="absolute inset-0 w-full h-full object-cover" />
        )}
      </div>
    );
  }
  return (
    <div className="relative aspect-[4/3] overflow-hidden border border-white/[0.06] bg-[#0A0A0A] flex items-center justify-center">
      <div className="absolute top-5 left-6 font-display text-[10px] tracking-[0.35em] uppercase text-white/30">
        Fase {m.n}
      </div>
      <motion.span
        initial={{ opacity: 0, scale: 0.85 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
        className="font-serif text-[26vw] md:text-[12rem] leading-none gold-text select-none"
      >
        {m.n}
      </motion.span>
    </div>
  );
}

function Chapter({ m, i }) {
  const right = i % 2 === 1;
  return (
    <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 items-center">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        className={`md:col-span-5 ${right ? "md:order-2 md:col-start-8" : ""}`}
      >
        <ChapterVisual m={m} />
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.9, delay: 0.12, ease: [0.22, 1, 0.36, 1] }}
        className={`md:col-span-6 ${right ? "md:order-1 md:col-start-1" : "md:col-start-7"}`}
      >
        <span className="block font-display text-[10px] tracking-[0.35em] uppercase text-[#D4AF37] mb-5">
          Capítulo {m.n}
        </span>
        <h3 className="font-serif text-white text-3xl md:text-5xl leading-tight">{m.t}</h3>
        <motion.div
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
          className="h-px bg-[#D4AF37]/50 w-16 my-7 origin-left"
        />
        <p className="font-display font-light text-white/75 text-base md:text-lg leading-relaxed max-w-[46ch]">
          {m.d}
        </p>
      </motion.div>
    </div>
  );
}

export default function Act7Method() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start center", "end center"] });
  const scaleY = useTransform(scrollYProgress, [0, 1], [0, 1]);

  return (
    <section data-testid="act-method" className="relative bg-[#030303] py-20 md:py-28 overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1 }}
          className="text-center max-w-[26ch] mx-auto mb-14 md:mb-20"
        >
          <span className="block font-display text-[10px] tracking-[0.4em] uppercase text-[#D4AF37] mb-7">
            El sistema
          </span>
          <h2 className="font-serif text-white leading-[1.05] tracking-tight text-4xl sm:text-5xl md:text-6xl">
            Diseñado para que <span className="italic gold-text">esta vez no abandones.</span>
          </h2>
        </motion.div>

        <div ref={ref} className="relative">
          {/* Progress line (desktop) */}
          <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-px -translate-x-1/2 bg-white/[0.06]">
            <motion.div style={{ scaleY }} className="w-full h-full bg-[#D4AF37]/50 origin-top" />
          </div>

          <div className="space-y-20 md:space-y-28">
            {METHOD.map((m, i) => (
              <Chapter key={m.n} m={m} i={i} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
